import React, { useState, useEffect } from 'react';
import { MwInputFile, MwSelectorProduct, MwButton, MwSpinner, MwSelector } from '../ui';
import { FaTimes, FaRegSave, FaClipboardList, FaFileInvoice } from 'react-icons/fa';
import { useCurrent, useFetch, usePost, useUploadFile } from '../../hooks';
import { useNavigate, useParams } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import CardHeadeWithActions from './../ui/CardHeadeWithActions';
import useDeleteWBody from './../../hooks/useDeleteWBody';
import { useTranslation } from 'react-i18next';
import OsMwSelectorAccount from '../OsRequisition/RequisitionComponents/OsMwSelectorAccount';

const OsRequisitionCreatePurchases = () => {
  const [t, i18n] = useTranslation('global');
  const { id } = useParams();
  const { tenant } = useParams();
  const navigate = useNavigate();

  // States for form fields
  const [selectedFile, setSelectedFile] = useState(null);
  const [fileKey, setFileKey] = useState(null);
  const [rows, setRows] = useState([]);
  const [subAccount, setSubAccount] = useState('');
  const [warehouses, setWarehouses] = useState([]);
  const [reqNo, setReqNo] = useState('');
  const [reqNote, setReqNote] = useState('');
  const [reqAttach, setReqAttach] = useState(null);
  const [reqDate, setReqDate] = useState(new Date().toISOString().split('T')[0]);
  const [fromWarehouse, setFromWarehouse] = useState(null);
  const [toWarehouse, setToWarehouse] = useState(null);
  const [reqType, setReqType] = useState('PUSH'); // Default to PASH (receive)
  const [fileLocation, setFileLocation] = useState(null);
  const [invoiceData, setInvoiceData] = useState(null);
  const isRTL = i18n.dir() === 'rtl';

  // Custom hooks for fetching and updating data
  const { currentTenantId, currentCompanyId, currentBranchId, userName } = useCurrent();
  const { data: postData, postData: sendPostData, loading: postLoading, error: postError } = usePost();

  // Fetch invoice data by ID
  const invoiceUrl = `${process.env.REACT_APP_INV_API_PURCHASES_BASE_URL}/invoices/show/${id}`;
  const { data: fetchedInvoiceData, loading: invoiceLoading, error: invoiceError } = useFetch(invoiceUrl);
  const RequisitionsNumber = `${process.env.REACT_APP_INVENTORY_API_SERVER_BASE_URL}/requisitions/gen-code/${currentTenantId}/${currentCompanyId}/${currentBranchId}`;

    const { data: NumberData, loading: NumberLoading, error: NumberError } = useFetch(RequisitionsNumber);
  
console.log("fetchedInvoiceData",fetchedInvoiceData)
  // Fetch warehouses data
  const warehousesUrl = `${process.env.REACT_APP_INVENTORY_API_SERVER_BASE_URL}/warehouses/${currentTenantId}/${currentCompanyId}/${currentBranchId}`;
  const { data: warehousesData, loading: warehousesLoading, error: warehousesError } = useFetch(warehousesUrl);

  // Set warehouses data when fetched
  useEffect(() => {
    if (warehousesData && warehousesData.data) {
      setWarehouses(warehousesData.data);
      // If there's only one warehouse, select it automatically
      if (warehousesData.data.length === 1) {
        setFromWarehouse(warehousesData.data[0].id.toString());
      }
    }
  }, [warehousesData]);

  // Set invoice data when fetched
// In the useEffect for fetchedInvoiceData
useEffect(() => {
  if (fetchedInvoiceData) {
    const data = fetchedInvoiceData;
    setInvoiceData(data);
    
    setReqNote(data.notes ? JSON.parse(data.notes) : '');
    setReqDate((data.inv_date || '').split(' ')[0]);
    
    if (data.inv_details && data.inv_details.length > 0) {
      const normalizedRows = data.inv_details.map((item) => {
        const qty = parseFloat(item.qty) || 0;
        const price = parseFloat(item.price) || 0;
        const totalPrice = parseFloat(item.total_price) || 0;
        
        // Check if product_id is null, "0", or invalid
        const isInvalidProduct = !item.product_id || item.product_id === "0";
        
        return {
          item: isInvalidProduct ? `${item.product_name || ''} (غير متوفر في المستودع)` : (item.product_name || ''),
          product_id: item.product_id || '',
          product_uom_id: item.unit_id || '',
          product_uom_name: item.uom || '',
          product_uom_template_id: item.uom_template_id || '',
          quantity: qty,
          balanceBefore: 0,
          balanceAfter: qty,
          unitPrice: price,
          total: totalPrice,
          isInvalidProduct: isInvalidProduct // Flag to mark invalid products
        };
      });
      setRows(normalizedRows);
    }
  }
}, [fetchedInvoiceData]);

  const {
    location,
    loading: uploadLoading,
    error: uploadError,
    handleUpload
} = useUploadFile(['image/png', 'image/jpeg', 'image/gif', 'image/webp','application/pdf', 'image/svg+xml', 'image/bmp', 'image/tiff'], 'requisitions');

  useEffect(() => {
    if (location) {
      setFileKey(location);
      setFileLocation(location);
      setSelectedFile({
        name: reqAttach?.name || 'Uploaded file',
        type: reqAttach?.type || 'application/octet-stream',
        url: location
      });
    }
  }, [location]);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setReqAttach(file);
      handleUpload(e);
    }
  };

  const { deleteItem, loading: deleteLoading, error: deleteError } = useDeleteWBody();

  const handleRemoveFile = async () => {
    if (fileKey) {
      try {
        await deleteItem(process.env.REACT_APP_UPLOADS_API_BASE_URL, { keyFile: fileKey });
        URL.revokeObjectURL(selectedFile?.url);
        setSelectedFile(null);
        setReqAttach(null);
        setFileKey(null);
        setFileLocation(null);
        
        // Reset the file input
        const fileInput = document.getElementById('file_upload');
        if (fileInput) {
          fileInput.value = '';
        }
      } catch (error) {
        toast.error(t('deleted.error_delete_file'), {
          position: "top-center",
          autoClose: 3000,
          rtl: isRTL,
          theme: "colored",
        });
      }
    }
  };
  const handleSave = async () => {
    if (rows.length === 0) {
      toast.warning(t('requisition.no_products_available') || "لا توجد منتجات للإضافة", {
        position: "top-center",
        autoClose: 3000,
        rtl: isRTL,
        theme: "colored",
      });
      return;
    }
  
    if (!validateFields()) {
      toast.error(t('deleted.fill_required'), {
        position: "top-center",
        autoClose: 3000,
        rtl: isRTL,
        theme: "colored",
      });
      return;
    }
  
    // Add a state to prevent multiple clicks/submissions
    if (postLoading) return;
  
    // Filter out invalid products once, instead of repeatedly
    const validItems = rows.filter(row => !row.isInvalidProduct);
    
    // Check if we have any valid products left
    if (validItems.length === 0) {
      toast.warning(t('requisition.no_valid_products') || "لا توجد منتجات صالحة للإضافة", {
        position: "top-center",
        autoClose: 3000,
        rtl: isRTL,
        theme: "colored",
      });
      return;
    }
    
    const requisitionUrl = `${process.env.REACT_APP_INVENTORY_API_SERVER_BASE_URL}/requisitions/master`;
    
    // Create the item data array outside the main object definition for better performance
    const itemsData = validItems.map((row) => ({
      product_id: row.product_id,
      product_name: row.item,
      product_uom_id: row.product_uom_id,
      product_uom_name: row.product_uom_name,
      product_uom_template_id: row.product_uom_template_id,
      qty: row.quantity,
      balance_before: row.balanceBefore,
      balance_after: row.balanceAfter,
      total: row.total,
    }));
  
    const saveData = {
      warehouse_id: fromWarehouse,
      req_type: reqType,
      req_no: reqNo,
      req_note: reqNote,
      req_attach: fileKey,
      req_status: 1,
      req_date: reqDate,
      account_no: subAccount,
      source_ref_no: id,
      source_type: "PURCHASE",
      tenant_id: currentTenantId,
      company_id: currentCompanyId,
      branch_id: currentBranchId,
      created_by: userName,
      items: itemsData,
    };

    console.log("saveData",saveData);
    
  
    try {
      await sendPostData(requisitionUrl, saveData);
    } catch (error) {
      console.error("Save error:", error);
      toast.error(t('deleted.error_saving_data'), {
        position: "top-center",
        autoClose: 3000,
        rtl: isRTL,
        theme: "colored",
      });
    }
  };
  // Validate fields
  const validateFields = () => {
    // Check required fields
    if (!reqDate || !fromWarehouse || !reqType || !reqNo) {
      return false;
    }

    if (reqType === 'TRANS' && (!toWarehouse || toWarehouse === '')) {
      return false;
    }
  
    // Check if there are any rows
    if (rows.length === 0) {
      return false;
    }
  
    // Validate each row
    for (const row of rows) {
      if (!row.product_id || !row.quantity) {
        return false;
      }
    }
  
    return true;

    
  };

  useEffect(() => {
    if (postError) {
      if (postError.message == "Request failed with status code 401" || 
          postError.message?.includes('exists')) {
            toast.warn("تم إنشاء إذن استلام مسبقًا بنفس رقم الفاتورة.",{
                position: "top-center",
          autoClose: 3000,
          rtl: isRTL        });
      } else {
        toast.error(postError.message || t('deleted.error_fetching_data'), {
          position: "top-center",
          autoClose: 3000,
          rtl: isRTL,
          theme: "colored",
        });
      }
    }
  }, [postError, isRTL, t]);

useEffect(() => {
  if (NumberData?.data) {
    // Get the NumberData.data as a string
    const dataString = String(NumberData.data);
    
    // Remove the first 3 digits and replace with PUR
    const formattedNumber = "PUR" + dataString.substring(3);
    
    setReqNo(formattedNumber);
  }
}, [NumberData]);
  useEffect(() => {
    if (postData) {
      if (postData.status === 1) {
        toast.success(t('deleted.data_saved_successfully'), {
          position: "top-center",
          autoClose: 3000,
          rtl: isRTL,
          theme: "colored",
        });
        // Reset form or redirect here if needed
        setTimeout(() => {
          navigate(`/${tenant}/invoice-requisition`);
        }, 1500);
      } else {
        toast.error(postError || t('deleted.error_saving_data'), {
          position: "top-center",
          autoClose: 3000,
          rtl: isRTL,
          theme: "colored",
        });
      }
    }
  }, [postData, postError, navigate, tenant, t, isRTL]);

  const handleCancel = () => {
    navigate(`/${tenant}/invoice-requisition`);
  };

  // Format numbers to two decimal places
  const formatNumber = (number) => {
    return Number(number).toFixed(2);
  };

  // Styles for inputs and labels
  const inputStyles = `w-full p-2 border border-gray-300 rounded-md text-gray-700 font-medium focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 bg-white text-sm ${isRTL ? 'text-right' : 'text-left'}`;
  const labelStyles = `block text-sm mb-1 text-gray-600 font-medium ${isRTL ? 'text-right' : 'text-left'}`;
  const smallInputStyles = `w-full p-1.5 border border-gray-300 rounded-md text-gray-700 text-sm focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 bg-white ${isRTL ? 'text-right' : 'text-left'}`;
  const centeredInputStyles = `${smallInputStyles} text-center`;

  if (invoiceLoading || warehousesLoading) {
    return (
      <div className="flex justify-center items-center h-[calc(100vh-100px)]">
        <MwSpinner size="lg" />
      </div>
    );
  }

  return (
    <div className="bg-white rounded-lg p-2 h-[calc(100vh-100px)] overflow-y-scroll custom-scrollbar border border-gray-200 shadow-sm"
      dir={isRTL ? 'rtl' : 'ltr'}>
      <ToastContainer
        position="top-center"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={isRTL}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
        style={{ top: '60px' }}  
      />
      <CardHeadeWithActions title={
         <div className='flex text-sm items-center gab-2 py-1'>
          <FaFileInvoice className="inline-block mx-1" />
<p>
  
{t('deleted.create_purchase_order_for_receipt')}      
</p>
  </div>
      }>
        <MwButton
          actionType="button"
          inGroup={true} 
          type="saveBtn"  
          onClick={handleCancel}
          disabled={postLoading}
          classNameCustom={postLoading ? "opacity-50 cursor-not-allowed" : ""}
        >
         إدارة التحويلات
        </MwButton>
      </CardHeadeWithActions>

      <div className='flex justify-end mt-7'>
        <MwButton
          actionType="button"
          inGroup={true}
          type="saveBtn"
          size='sm'
          onClick={handleSave}
          disabled={postLoading}
          classNameCustom={postLoading ? "opacity-50 cursor-not-allowed" : ""}
        >
          {postLoading ? (
            <span>{t('requisition.saving')}</span>
          ) : (
            <>
              <FaRegSave />
              {t('requisition.save')}
            </>
          )}
        </MwButton>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
        {/* Requisition Details */}
        <div className="border border-gray-200 rounded-lg p-6">
          <h5 className={`${isRTL ? 'text-right' : 'text-left'} text-gray-700 mb-4 font-bold text-sm`}>
            {t('requisition.requisition_information')}
          </h5>
          <div className="grid grid-cols-2 gap-3">
            <div>
              <label className={labelStyles}>{t('requisition.type')}</label>
              <input
                type="text"
                value={t('requisition._receive')}
                className={`${inputStyles} w-full`}
                readOnly
              />
            </div>
            <div>
              <label className={labelStyles}>{t('requisition.date')}</label>
              <input
                type="date"
                value={reqDate}
                onChange={(e) => setReqDate(e.target.value)}
                className={`${inputStyles} w-full`}
              />
            </div>
          </div>
        </div>

        {/* Warehouse Selection */}
        <div className="border border-gray-200 rounded-lg p-6">
          <h5 className={`${isRTL ? 'text-right' : 'text-left'} text-gray-700 mb-4 font-bold text-sm`}>
            {t('requisition.Store_Information')}
          </h5>
          <div>
            <label className={labelStyles}>{t('requisition.from')}</label>
            {warehousesLoading ? (
              <div className="p-2 text-gray-500 text-sm">{t('requisition.loading')}</div>
            ) : warehousesError ? (
              <div className="p-2 text-red-500 text-sm">{t('deleted.error_fetching_data')}</div>
            ) : warehouses && warehouses.length > 0 ? (
              <MwSelector
                withSearch={false}
                _data={warehouses.map((warehouse) => ({
                  _id: warehouse.id,
                  label: warehouse.name_ar || warehouse.name_en,
                  value: warehouse.id,
                }))}
                dataType="labelValue"
                setSelectedItem={(item) => setFromWarehouse(item.value)}
                selectedItem={
                  fromWarehouse
                    ? {
                        _id: fromWarehouse,
                        label: warehouses.find((w) => w.id === parseInt(fromWarehouse))?.name_ar || 
                              warehouses.find((w) => w.id === parseInt(fromWarehouse))?.name_en,
                        value: fromWarehouse,
                      }
                    : null
                }
                initalValue={t('reports.Choose_Warehouse')}
                withLabel={false}
              />
            ) : (
              <div className="p-2 text-gray-500 text-sm">{t('deleted.no_data')}</div>
            )}
          </div>
        </div>
      </div>

      {/* Item Details */}
      <div className="border border-gray-200 rounded-lg p-6 mt-4">
        <h5 className={`${isRTL ? 'text-right' : 'text-left'} text-gray-700 mb-4 font-bold text-sm`}>
          {t('requisition.item_details')}
        </h5>

        {/* Column Headers */}
        <div
          className="mb-2 text-xs text-gray-800 bg-slate-200 font-medium p-2 rounded-md"
          style={{
            display: 'grid',
            gridTemplateColumns: '0.5fr 6.5fr 1fr 1fr 1fr 1fr 2fr',
            gap: '0.5rem'
          }}
        >
          <div className="text-center text-xs">#</div>
          <div className={`${isRTL ? 'text-right' : 'text-left'}`}>
            {t('requisition.item')}
          </div>
          <div className="text-center">{t('requisition.purchase_price')}</div>
          <div className="text-center">{t('requisition.quantity')}</div>
          <div className="text-center">{t('requisition.balance_before')}</div>
          <div className="text-center">{t('requisition.balance_after')}</div>
          <div className="text-center">{t('requisition.total')}</div>
        </div>

        {/* Rows */}
{rows.map((row, index) => (
  <div
    key={index}
    className={`text-gray-700 items-center relative mb-4 ${
      index === rows.length - 1 ? '' : 'border-b border-gray-100 pb-2'
    } ${row.isInvalidProduct ? 'opacity-50' : ''}`}
    style={{
      display: 'grid',
      gridTemplateColumns: '0.5fr 6.5fr 1fr 1fr 1fr 1fr 2fr',
      gap: '0.5rem'
    }}
  >
    {/* Number column */}
    <div className="text-center text-xs">{index + 1}</div>

    {/* Item column */}
    <div>
      <input
        type="text"
        value={row.item || ""}
        readOnly
        className={`${smallInputStyles} bg-gray-50 text-gray-800 font-medium ${row.isInvalidProduct ? 'text-red-500' : ''}`}
      />
    </div>

    {/* Price column */}
    <div>
      <input
        type="text"
        value={formatNumber(row.unitPrice)}
        readOnly
        className={`w-full px-3 py-2 text-xs border border-gray-300 rounded-md text-center bg-gray-50 ${row.isInvalidProduct ? 'bg-gray-100' : ''}`}
      />
    </div>

    {/* Quantity column */}
    <div>
      <input
        type="text"
        value={row.quantity}
        readOnly
        className={`w-full px-3 py-2 text-xs border border-gray-300 rounded-md text-center bg-gray-50 ${row.isInvalidProduct ? 'bg-gray-100' : ''}`}
      />
    </div>

    {/* Balance Before column */}
    <div>
      <input
        type="text"
        value={formatNumber(row.balanceBefore)}
        readOnly
        className={`w-full px-3 py-2 text-xs border border-gray-300 rounded-md text-center bg-gray-50 ${row.isInvalidProduct ? 'bg-gray-100' : ''}`}
      />
    </div>

    {/* Balance After column */}
    <div>
      <input
        type="text"
        value={formatNumber(row.balanceAfter)}
        readOnly
        className={`w-full px-3 py-2 text-xs border border-gray-300 rounded-md text-center bg-gray-50 ${row.isInvalidProduct ? 'bg-gray-100' : ''}`}
      />
    </div>

    {/* Total column */}
    <div>
      <input
        type="text"
        value={formatNumber(row.total)}
        readOnly
        className={`w-full px-3 py-2 text-xs border border-gray-300 rounded-md text-center bg-gray-50 font-medium ${row.isInvalidProduct ? 'bg-gray-100' : ''}`}
      />
    </div>
  </div>
))}
        {/* Total Summary Section */}
        <div className="border-t border-gray-200 pt-3 mt-4">
          <div className="grid grid-cols-12 gap-4">
            <div className="col-span-8" />
            <div className="col-span-4">
              <div className="space-y-3">
                <h3 className="text-gray-600 font-semibold text-right text-sm">
                  {t('requisition.total_summary')}:
                </h3>
                <input
                  type="text"
                  value={formatNumber(
                    rows.reduce((sum, row) => sum + row.total, 0)
                  )}
                  readOnly
                  className="w-full px-2 py-1 text-base border border-gray-300 rounded-lg  font-semibold text-gray-600 text-center "
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Account Information */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
        <div className="border border-gray-200 rounded-lg p-6">
          <h5 className={`${isRTL ? 'text-right' : 'text-left'} text-gray-700 mb-4 font-bold text-sm`}>
            {t('requisition.account_info')}
          </h5>
          <div className="space-y-4">
            <div className="grid grid-cols-1 gap-5">
              <div>
                <label className={labelStyles}>{t('requisition.sub_account')}</label>
                <OsMwSelectorAccount
                  onChangeCallback={(selectedAccount) => {
                    setSubAccount(selectedAccount.account_no);
                  }}
                  withLabel={false}
                  initalValue={subAccount}
                />
              </div>
              <div>
                <label className={labelStyles}>{t('requisition.number')}</label>
                <input
                  style={{textAlign: 'center'}}
                  type="text"
                  className={`${inputStyles}`}
                  value={reqNo}
                  onChange={(e) => setReqNo(e.target.value)}
                />
              </div>
            </div>
          </div>
        </div>

        {/* Additional Information */}
        <div className="border border-gray-200 rounded-lg p-6">
          <h5 className={`${isRTL ? 'text-right' : 'text-left'} text-gray-700 mb-4 font-bold text-sm`}>
            {t('requisition.other_info')}
          </h5>
          <div className="space-y-4">
            <div className="grid grid-cols-1 gap-4">
              <div>
                <label className={labelStyles}>{t('requisition.notes')}</label>
                <textarea
                  className={`${inputStyles} min-h-[85px]`}
                  value={reqNote}
                  onChange={(e) => setReqNote(e.target.value)}
                />
              </div>
              <div>
                <label className={labelStyles}>{t('requisition.attachments')}</label>
                <div className="border-2 border-dashed border-gray-300 rounded-lg p-4 bg-white">
                  <MwInputFile
                    onChangeHandler={handleFileChange}
                    acceptTypes="image/*,.webp,.svg,.bmp,.tiff,application/pdf,.pdf"
                    label={t('requisition.upload_file')}
                    id="file_upload"
                    isMultiple={false}
                    isSmall={false}
                    disabled={uploadLoading}
                  />
                  {selectedFile && (
                    <div className="mt-4">
                      <div className="flex items-center justify-between mb-2">
                        <p className="text-sm text-gray-600">{t('requisition.selected_file')}: {selectedFile.name}</p>
                        <button
                          onClick={handleRemoveFile}
                          className="p-1 hover:bg-red-50 rounded-full text-red-500 hover:text-red-700 transition-colors"
                          title="إلغاء الملف"
                          disabled={deleteLoading}
                        >
                          <FaTimes size={16} />
                        </button>
                      </div>
                      {selectedFile.type.startsWith('image/') || selectedFile.name.toLowerCase().endsWith('.webp') ? (
                        <img src={selectedFile.url} alt="Preview" className="max-w-xs mx-auto" />
                      ) : selectedFile.type === 'application/pdf' && (
                        <div className="flex items-center justify-center">
                          <iframe 
                            src={selectedFile.url} 
                            className="w-full h-[200px]" 
                            title="PDF Preview"
                          ></iframe>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OsRequisitionCreatePurchases;